import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
import Login from "../views/Login.vue";
import NotFound from "../views/404.vue";
import Home from "../views/Home.vue";
import Main from "../views/Main.vue";
import Table from "../views/nav1/Table.vue";
import userInfo from "../views/nav1/userInfo.vue";


let routes = [
  {
    path: "/login",
    component: Login,
    name: "",
    hidden: true,
  },
  {
    path: "/404",
    component: NotFound,
    name: "",
    hidden: true,
  },
  {
    path: "/",
    component: Home,
    name: "Mục Lục",
    iconCls: "el-icon-message", //图标样式class
    children: [
      { path: "/main", component: Main, name: "Mục Lục", hidden: true },
      { path: "/userInfo", component: userInfo, name: "Thông Tin" },
      { path: "/table", component: Table, name: "Danh Sách Đơn Hàng" },
    ],
  },
  {
    path: "*",
    hidden: true,
    redirect: { path: "/404" },
  },
];

const router = new VueRouter({
  mode:'history',
  routes,
});
export default router;
